import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';

import { translate, useLocale } from '@/shared/i18n';
import { seoController, useSeoHead, type SeoDescriptor } from '@/shared/lib';

const useAppSeo = (): void => {
  const route = useRoute();
  const { locale } = useLocale();
  const descriptor = computed<SeoDescriptor | null>(() => {
    void locale.value;
    return (route.meta.seo as SeoDescriptor | undefined) ?? null;
  });

  watch(
    descriptor,
    (value: SeoDescriptor | null): void => {
      if (value === null) {
        seoController.clearRoute();
        return;
      }

      seoController.setRoute(value);
    },
    { immediate: true },
  );

  useSeoHead(seoController.resolved, translate);
};

export { useAppSeo };
